import React from "react";

//components
import { IProviderAddon } from "../../../../../../compare/interfaces/IProviderAddon";

//styles
import styles from "../../AIAVitality/Cart/ResultAIAVitality.module.scss";;


interface IResultChubbLifetimeRewardProps {
    providerAddOn: IProviderAddon;
}

const ResultChubbLifetimeReward: React.FC<IResultChubbLifetimeRewardProps> = (props) => {
    const { providerAddOn } = props;

    return (
        <div className={"layout-flex-column"}>
            <div className={styles["container_row"]}>
                <h4 className="space-m gap-pre-s"> {providerAddOn.addOnName} </h4>
            </div>
            <span className="gap-pre-m text-small text-light">
                {providerAddOn.quoteAmountInfoText}
                {/*<a className="space-pre-m" href="/article/lifedirect-aia-vitality-offer" target="_blank">More info</a>*/}
            </span>
        </div>
    );
};

export default ResultChubbLifetimeReward;
